import Api from '@/api/Api';
import uploadWithAuth from '@/api/ApiUpload';
import errorHandler from '@/utils/plugins/ErrorHandler';

const RESOURCE = '/api/invoices';

export default {
    getInvoices(params) {
        return Api()
            .get(RESOURCE, { params })
            .catch((err) => errorHandler(err, null));
    },

    getInvoice(id) {
        return Api()
            .get(`${RESOURCE}/${id}`)
            .catch((err) => errorHandler(err, null));
    },

    importFromExcel(file) {
        const formData = new FormData();
        formData.append('file', file);
        return uploadWithAuth({
            method: 'post',
            url: process.env.VUE_APP_BASE_URI + `${RESOURCE}/import`,
            data: formData,
            headers: {
                'Content-Type': 'multipart/form-data',
                Accept: 'application/json',
            },
        });
    },

    syncHolded(from, to) {
        return Api().post(`${RESOURCE}/sync-holded`, { from, to });
    },

    uploadPdf(id, file) {
        const formData = new FormData();
        formData.append('file', file);
        return uploadWithAuth({
            method: 'post',
            url: process.env.VUE_APP_BASE_URI + `${RESOURCE}/${id}/upload-pdf`,
            data: formData,
            headers: {
                'Content-Type': 'multipart/form-data',
                Accept: 'application/json',
            },
        });
    },

    markPaid(id) {
        return Api().put(`${RESOURCE}/${id}/mark-paid`, {});
    },

    markPaymentPlan(id) {
        return Api().put(`${RESOURCE}/${id}/mark-payment-plan`, {});
    },

    resolveClient(id, clientIri) {
        return Api().put(`${RESOURCE}/${id}/resolve-client`, { client: clientIri });
    },

    sendNotification(id) {
        return Api().post(`${RESOURCE}/${id}/send-notification`, {});
    },

    sendBulkNotifications(invoiceIds) {
        return Api()
            .post(`${RESOURCE}/send-bulk-notifications`, { invoiceIds })
            .catch((err) => errorHandler(err, null));
    },

    requestPdf(id) {
        return Api()
            .post(`${RESOURCE}/${id}/request-pdf`, {})
            .catch((err) => errorHandler(err, null));
    },

    // FS-S01: descarga autenticada (blob), ya no un <a href> directo a una
    // ruta pública estática. Sin .catch: el componente decide qué mostrar
    // si falla (p. ej. 404 cuando el PDF todavía no se ha sincronizado).
    downloadPdf(id) {
        return Api().get(`${RESOURCE}/${id}/download-pdf`, { responseType: 'blob' });
    },

    getKpis(params) {
        return Api()
            .get(`${RESOURCE}/kpis`, { params })
            .catch((err) => errorHandler(err, null));
    },

    processNotifications() {
        return Api().post(`${RESOURCE}/process-notifications`, {});
    },

    resetTestData() {
        return Api().post(`${RESOURCE}/reset-test-data`, {});
    },
};
